import { Alert } from '@carsys/ui'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

/**
 * AnyErrorsMessage will display a generic error message whenever any error is present after attempting to submit.
 *  this is helpfull for large forms, where the user might have to scroll
 * @returns a react component
 */
export const AnyErrorsMessage = ({ message }: { message?: string }) => {
  const { t } = useTranslation()
  const formikContext = useFormikContext()

  // if formik.errors has any keys, there was an error
  return formikContext.submitCount && Object.keys(formikContext.errors).length > 0 ? (
    <Alert variant='standard' severity='error'>
      {message || t('Form.Error.GenericError')}
    </Alert>
  ) : null
}
